const HEADER_BLOCK_DATA = {
  image: '',
  imageMobile: '',
  title: '',
  titleMobile: '',
  description: '',
  descriptionMobile: '',
  buttonText: '',
  buttonTextMobile: '',
  beforeText: '',
  afterText: '',
  isShowVideo: false,
  videoUrl: '',
  imageUrl: '',
  imageUrlMobile: '',
};

export default HEADER_BLOCK_DATA;
